function DazMintPass(mintpassAddress, mintAddress, tokens) {
    this.mintpassAddress = mintpassAddress;
    this.mintAddress = mintAddress;
    this.enabled = false;
    this.maxPerTransaction = 0;
    this.initialized = false;
    this.tokens = tokens;
    this.mintpassContract = new dazeth.web3.eth.Contract(window.dazContracts["ERC1155Supply"], mintpassAddress);
    this.mintContract = new dazeth.web3.eth.Contract(window.dazContracts["IMintpassMintable"], mintAddress);
}

DazMintPass.prototype.init = async function () {
    const balances = await this.getBalances(this.tokens);
    this.enabled = true;
    this.initialized = true;
    return {
        enabled: this.enabled,
        initialized: this.initialized,
        balances,
    }
}

DazMintPass.prototype.data = async function (tokens, qtys) {
    return {
        tokens: tokens,
        qtys: qtys
    }
}

DazMintPass.prototype.getBalances = async function (tokens) {
    const balance = {};
    const promises = [];
    for (let i = 0; i < tokens.length; i++) {
        const tokenID = tokens[i];
        let p = this.mintpassContract.methods.balanceOf(dazethutil.me(), tokenID).call().then(count => {
            balance[tokenID] = parseInt(count, 10);
            return balance;
        }, (e) => {
            throw `balanceOf error for ${tokenID}`;
        }).catch(e => {
            throw `balanceOf error for ${tokenID}`;
        });
        promises.push(p);
    }
    await Promise.all(promises);
    return balance;
}

DazMintPass.prototype.mint = async function (data) {
    data = Object.assign({tokens: [], qtys: []}, data)

    const balances = await this.getBalances(data.tokens);
    for (let i = 0; i < data.tokens.length; i++) {
        const tokenID = data.tokens[i];
        if (balances[tokenID] < data.qtys[i]) {
            throw `insufficient quantities of ${tokenID}`;
        }
        data.tokens[i] = data.tokens[i].toString();
        data.qtys[i] = data.qtys[i].toString();
    }

    return {
        tokens: data.tokens,
        qtys: data.qtys
    }
}

DazMintPass.prototype.complete = async function (data, mint) {
    return await this.mintContract.methods.mintWithPass(data.tokens, data.qtys).send({
        from: dazethutil.me(),
    }).on('transactionHash', (hash) => mint.onTransactionHash(data, hash)).catch((err) => {
        throw err;
    });
}
